import { gql } from '@apollo/client'

// Mirrors the fields CreatorsListV2 reads off each entity. The shared CreatorFragment lives in a .js
// file, which codegen doesn't scan (documents are .ts/.tsx only), so it can't be interpolated here.
export const BRAND_CREATOR_FRAGMENT = gql`
  fragment BrandCreator on Creator {
    groupId
    creatorId
    provider
    title
    thumbnail
    country
    isBrand
    isBrandGroup
    isTrending
    subscribers
    subscribersVariation
    performanceAnalytics: performance {
      analytics(filter: { periodInMonths: 1 }) {
        avgEngagement
        avgEngagementVariation
        avgViews
        avgViewsVariation
      }
    }
    talkingAboutInfo {
      entity {
        ... on Topic {
          topicId
          title
        }
        ... on TerritoryBasic {
          territoryId
          name
        }
        ... on CreatorTalkingAboutTag {
          title
        }
      }
    }
  }
`
